import ContenidoTipoFlashcards from './contenido-tipo-flashcards';
export default ContenidoTipoFlashcards;